import { Image } from 'exceljs'

export function getExtensionFromDataUrl(dataUrl: string): Image['extension'] | undefined {
  const match = dataUrl.match(/[^:/]\w+(?=;|,)/)
  if (!match) return undefined

  let ext = match[0].toLowerCase()

  if (ext === 'jpg') ext = 'jpeg'
  if (ext === 'png' || ext === 'jpeg' || ext === 'gif') return ext

  return undefined
}

export function readFileAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export function getImageDimensions(dataUrl: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = reject
    img.src = dataUrl
  })
}

export function base64ToUint8Array(dataUrl: string): Uint8Array {
  const base64 = dataUrl.split(',')[1]
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}
